<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="关键字">
              <a-input
                v-model="queryParam.keywords"
                placeholder="用户名/手机"
              />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="日期区间">
              <a-range-picker
                v-model="time_range_moment"
                style="width: 100%"
                format="YYYY-MM-DD HH:mm:ss"
                :showTime="{
                  defaultValue: [
                    moment('00:00:00', 'HH:mm:ss'),
                    moment('23:59:59', 'HH:mm:ss'),
                  ],
                }"
              />
            </a-form-item>
          </a-col>

          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="调用次数">
                <a-input-number
                  v-model="queryParam.callNo"
                  style="width: 100%"
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="更新日期">
                <a-date-picker
                  v-model="queryParam.date"
                  style="width: 100%"
                  placeholder="请输入更新日期"
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="使用状态">
                <a-select
                  v-model="queryParam.useStatus"
                  placeholder="请选择"
                  default-value="0"
                >
                  <a-select-option value="0">全部</a-select-option>
                  <a-select-option value="1">关闭</a-select-option>
                  <a-select-option value="2">运行中</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="使用状态">
                <a-select placeholder="请选择" default-value="0">
                  <a-select-option value="0">全部</a-select-option>
                  <a-select-option value="1">关闭</a-select-option>
                  <a-select-option value="2">运行中</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="(!advanced && 6) || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="
                (advanced && { float: 'right', overflow: 'hidden' }) || {}
              "
            >
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button
                style="margin-left: 8px"
                @click="() => (queryParam = {})"
                >重置</a-button
              >
              <a @click="toggleAdvanced" style="margin-left: 8px" v-if="false">
                {{ advanced ? "收起" : "展开" }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator"></div>

    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      :alert="{
        show: true,
        clear: () => {
          this.selectedRowKeys = [];
        },
      }"
      :rowSelection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
      }"
    >
      <span slot="name" slot-scope="name, record">
        {{ record.name }}
      </span>

      <span slot="status2" slot-scope="name, record">
        <span v-if="record.status == 1">待审核</span>
        <span v-if="record.status == 2">已完成</span>
        <span v-if="record.status == 3">已拒绝</span>
      </span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="handleLogManage(record)">操作</a>
          <!-- <a-divider type="vertical" /> -->
        </template>
      </span>
    </s-table>

    <a-modal
      :maskClosable="false"
      title="详情"
      :width="600"
      style="top: 20px"
      :bodyStyle="{ maxHeight: '500px', overflowY: 'scroll' }"
      v-model="visible"
      @ok="visible = false"
    >
      <a-spin :spinning="saveLoading">
        <div style="margin-bottom:20px;padding-left:20px"><span style="width:60px;display: inline-block;text-align:right">姓名:</span><span>{{formData.name}}</span></div>
        <div style="margin-bottom:20px;padding-left:20px"><span style="width:60px;display: inline-block;text-align:right">手机号:</span><span>{{formData.phone}}</span></div>
        <div style="margin-bottom:20px;padding-left:20px"><span style="width:60px;display: inline-block;text-align:right">提现金额:</span><span>{{formData.price}}</span></div>
        <div style="margin-bottom:20px;padding-left:20px"><span style="width:60px;display: inline-block;text-align:right">申请时间:</span><span>{{formData.create_time_str}}</span></div>
        <div style="margin-bottom:20px;padding-left:20px"><span style="width:60px;display: inline-block;text-align:right">提现凭证:</span>
          <img style="width:200px" v-for="(item,i) in formData.pics_url" :key="i" :src="item" alt="" srcset="">
        </div>
      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">拒绝</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">通过</a-button>
      </template>
    </a-modal>
  </a-card>
</template>

<script>
import STable from "@/components/table/";
import ATextarea from "ant-design-vue/es/input/TextArea";
import AInput from "ant-design-vue/es/input/Input";
import moment from "moment";
import areaOptions from "@/utils/area";

import PriceInput from "@/components/PriceInput/";

import RSwitch from "@/components/RSwitch/";
import { getWithdrawalList,withdrawalStatusEdit } from "@/api/purchase";

import PicUploader from "@/components/PicUploader/";
export default {
  name: "WithdrawalList",
  components: {
    AInput,
    ATextarea,
    RSwitch,
    STable,
    PriceInput,
    PicUploader,
  },
  data() {
    return {
      areaOptions,
      time_range_moment: [],
      saveLoading: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      },
      form: this.$form.createForm(this),
      mdl: {},

      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      groupOptions: [],
      formData: { 
      },
      // 表头
      columns: [
        {
          title: "#",
          dataIndex: "id",
          sorter: true,
        },
        {
          title: "用户名",
          width: "200px",
          dataIndex: "name",
          scopedSlots: { customRender: "name" },
        },
        {
          title: "手机号",
          dataIndex: "phone",
        },
        {
          title: "提现金额",
          dataIndex: "price",
        },
        {
          title: "申请时间",
          dataIndex: "create_time_str",
        },
        {
          title: "状态",
          dataIndex: "status",
          scopedSlots: { customRender: "status2" },
        },
        {
          title: "操作",
          dataIndex: "action",
          width: "150px",
          scopedSlots: { customRender: "action" },
        },
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: (parameter) => {
        console.log("loadData");
        console.log(this.queryParam);
        this.queryParam.user_group_ids = [];

        if (this.time_range_moment[0] && this.time_range_moment[1]) {
          this.queryParam.time_range = [
            this.time_range_moment[0].format("YYYY-MM-DD HH:mm:ss"),
            this.time_range_moment[1].format("YYYY-MM-DD HH:mm:ss"),
          ];
        } else {
          this.queryParam.time_range = [];
        }
        this.queryParam = Object.assign(this.queryParam, parameter);
        return getWithdrawalList(this.queryParam).then((res) => {
          console.log("res");
          return res.data;
        });
      },

      selectedRowKeys: [],
      selectedRows: [],
      visible: false,
    };
  },
  created() {
    //      getRoleList({ t: new Date()})
  },
  mounted() {
    let self = this;
  },
  methods: {
    moment,
    handleOk(){
      let that=this
      withdrawalStatusEdit({id:this.formData.id,status:2}).then(res => {
          that.$message.success('操作成功')
          that.$refs.table.refresh()
          that.visible = false;
           
        }).catch(err =>{
          that.$message.error(err.data.msg);
        })
        let arr2=[]
        arr.map((item,i)=>{
          if(item!=undefined || item!=""){
            arr2.push(item)
          }
        })
    },
    handleCancel(){
      let that=this
      withdrawalStatusEdit({id:this.formData.id,status:3}).then(res => {
          that.$message.success('操作成功')
          that.$refs.table.refresh()
          that.visible = false;
           
        }).catch(err =>{
          that.$message.error(err.data.msg);
        })
    },
    handleLogManage(record) {
      this.visible = true;
      this.formData=record
    },
    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false);
    },

    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    toggleAdvanced() {
      this.advanced = !this.advanced;
    },

    resetSearchForm() {
      this.queryParam = {
        date: moment(new Date()),
      };
    },
  },
  watch: {
    /*
      'selectedRows': function (selectedRows) {
        this.needTotalList = this.needTotalList.map(item => {
          return {
            ...item,
            total: selectedRows.reduce( (sum, val) => {
              return sum + val[item.dataIndex]
            }, 0)
          }
        })
      }
      */
  },
};
</script>
